// essential
import { IAC_EVENT_TYPES, EVENT_HANDLER_TYPES } from '../constants';

// IAC
import { Navigator, IACCommunication } from '..';

// navigator modules
import { KeepAlive } from '../interface';
import { Connectivity } from './Connectivity';
import { EventHandler } from './EventHandler';

// interface
import { InterruptionInterface } from '../interface';

let connectionRetry: number;

/*
 * This service handles connection lost.
 * Just inherit the functions to show and hide messages.
 */
export class InterruptionHandler {

  private static onOnlineFixme() {
    InterruptionInterface.onOnlineFixme();

    const focusedApp = Navigator.getFocusedApplication()
    /* istanbul ignore next else */
    if (focusedApp) {
      // IAC notification
      IACCommunication.sendMessage(
        IACCommunication.createEvent(IAC_EVENT_TYPES.ONENABLED, {
          count: ++focusedApp.iacEnabledCounter,
        }),
        focusedApp,
      );
    }

    // Stop manual retries
    if (connectionRetry) {
      window.clearInterval(connectionRetry);
      connectionRetry = 0;
    }

    KeepAlive.call();
  }

  private static onOfflineInterruption() {
    InterruptionInterface.onOfflineInterruption();

    // IAC notification
    const focusedApp = Navigator.getFocusedApplication()
    /* istanbul ignore next else */
    if (focusedApp) {
      IACCommunication.sendMessage(
        IACCommunication.createEvent(IAC_EVENT_TYPES.ONDISABLED, {
          count: ++focusedApp.iacDisabledCounter,
        }),
        focusedApp,
      );
    }

    // Start manual retries
    if (!connectionRetry) {
      connectionRetry = window.setInterval(() => {
        if (Connectivity.online()) {
          EventHandler.trigger(EVENT_HANDLER_TYPES.CONNECTIVITY_ONLINE);
        }
      }, 10000);
    }
  }

  private static onScriptInterruption() {
    if (Connectivity.offline()) {
      EventHandler.trigger(EVENT_HANDLER_TYPES.CONNECTIVITY_OFFLINE);
    }
  }

  private static onKeepAliveInterruption() {
    // IAC notification
    const focusedApp = Navigator.getFocusedApplication()
    /* istanbul ignore next else */
    if (focusedApp) {
      IACCommunication.sendMessage(
        IACCommunication.createEvent(IAC_EVENT_TYPES.ONDISABLED, {
          count: ++focusedApp.iacDisabledCounter,
        }),
        focusedApp,
      );
    }
  }

  public static init(): void {
    EventHandler.bind(EVENT_HANDLER_TYPES.CONNECTIVITY_ONLINE, this.onOnlineFixme, this);
    EventHandler.bind(EVENT_HANDLER_TYPES.CONNECTIVITY_OFFLINE, this.onOfflineInterruption, this);
    EventHandler.bind(EVENT_HANDLER_TYPES.SCRIPT_INTERRUPTION, this.onScriptInterruption, this);
    EventHandler.bind(EVENT_HANDLER_TYPES.KEEPALIVE_FAILED, this.onKeepAliveInterruption, this);
  }
}
